import styled from 'styled-components';

type BulletSize = 6 | 8 | 10 | 12;

export type BulletProps = {
    size?: BulletSize;
};

function dimensions({ size = 6 }: Pick<BulletProps, 'size'>) {
    return `${size}px`;
}

const BulletElement = styled.span<BulletProps>`
    position: relative;
    display: inline-block;
    flex: none;
    background: ${({ theme }) => theme.ColorIconPrimary};
    width: ${dimensions};
    height: ${dimensions};
    border-radius: 50%;
`;

function Bullet(props: BulletProps) {
    return <BulletElement {...props} />;
}

export default Bullet;
